<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          <span>v{{ version }}&nbsp;</span>
          <span>© Designed by&nbsp;</span>
          <a href="https://polluxcoop.com/" class="font-weight-bold" target="_blank">Pollux&nbsp;</a>
          <span>{{ year }}&nbsp;</span>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item">
            <a href="http://albertsemillas.com.ar/" class="nav-link" target="_blank">Albert Semillas</a>
          </li>
          <li class="nav-item">
            <a href="http://albertsemillas.com.ar/nosotros/" class="nav-link" target="_blank">Nosotros</a>
          </li>
          <li class="nav-item">
            <a href="http://albertsemillas.com.ar/blog/" class="nav-link" target="_blank">Blog</a>
          </li>
          <li class="nav-item">
            <a href="http://albertsemillas.com.ar/contacto/" class="nav-link" target="_blank">Contacto</a>
          </li>
          <li class="nav-item d-none">
            <a href="http://www.creative-tim.com/license" class="nav-link" target="_blank">Licencia</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },

  computed: {
    version() {
      return this.$version;
    },
  },
};
</script>

<style scoped>
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
